import * as React from 'react';
import { OpgaveAfsnit } from '../../models/OpgaveAfsnit';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextFormGroup, RichTextFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationError, getValidationErrorsForCollection } from '../../infrastructure/ValidationResult';
import { SectionDynamic } from '../../uiComponents/layout/SectionDynamic';
import { EditorState } from 'draft-js';

export interface OpgaveAfsnitComponentProps {
    opgaveAfsnit: OpgaveAfsnit;
    index: number;
    removeOpgaveAfsnit: (key: any) => void;
    onAfsnitChanged: (fieldName: string, value: any, index: number) => void;
    errorMessages: ValidationError[];
    onEditorChange: (editorState: EditorState, index: number) => void;
    editorState: EditorState;
}

class OpgaveAfsnitComponent extends React.Component<OpgaveAfsnitComponentProps, any> {
    constructor(props: OpgaveAfsnitComponentProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onContentChanged = this.onContentChanged.bind(this);
    }

    onChange(field: string, value: string) {
        this.props.onAfsnitChanged(field, value, this.props.index);
    }

    onContentChanged(html: string) {
        this.props.onAfsnitChanged('indhold', html, this.props.index);
    }

    render() {
        var afsnitErrors = getValidationErrorsForCollection(this.props.errorMessages, 'opgaveafsnit', this.props.index);

        return (
            <SectionDynamic index={this.props.index} deleteOnClick={() => this.props.removeOpgaveAfsnit(this.props.index)}>
                <Row>
                    <Col md={8} mdOffset={2}>
                        <TextFormGroup
                            errorMessages={afsnitErrors}
                            label='Overskrift'
                            name='overskrift'
                            placeholder='Skriv overskrift'
                            value={this.props.opgaveAfsnit.overskrift}
                            onChange={this.onChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={8} mdOffset={2}>
                        <RichTextFormGroup
                            onEditorChange={(editorState: EditorState) => this.props.onEditorChange(editorState, this.props.index)}
                            editorState={this.props.editorState}
                        />
                    </Col>
                </Row>
            </SectionDynamic>
        );
    }
}

export default OpgaveAfsnitComponent;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/OpgaveAfsnitComponent.tsx